import React, {useMemo} from 'react';
import styled from 'styled-components';
import AddIcon from "resources/img/Icon-add.svg";

export const PRICING_STRATEGIES = {
  basePrice: 'BASE_PRICE',
  mktPrice: 'MKT_PRICE',
  timeBasedPrice: 'TIME_SPECIFIC_PRICE',
}

const VariantTitle = styled.span`
  font-size: 16px/19px;
  font-weight: bold;
  margin: 0;
  justify-self: start;
`;

const BoldLabel = styled.span`
  font-size: 16px/19px;
  font-weight: bold;
  margin: 0;
  justify-self: end;
`;

const NormalLabel = styled.span`
    font-size: 16px/19px;
    margin: 0;
    justify-self: end;
`;

const Img = styled.img`
  width: 16px;
  height: 16px;
  justify-self: end;
`;

const VariantRow = ({variant, order, setOrder}) => {

  const handleOrderByVariant = (variantId) => {
    setOrder(order => ({ ...order, [variantId]: (order[variantId] || 0) + 1 }))
  }

  const price = useMemo(()=>{    
    switch(variant.pricingStrategy){
      case PRICING_STRATEGIES.basePrice:
        return variant.basePrice;
      case PRICING_STRATEGIES.mktPrice:
        return 'MKT';
      case PRICING_STRATEGIES.timeBasedPrice:
        //Function to get the time specific price
        break;
      default:
        if(!variant.pricingStrategy && !!variant.config && !!variant.config.marketPrice)
          return 'MKT';
        return '';
    }

  },[]);
  
  return (
    <>
      <VariantTitle>{variant.title}</VariantTitle>
      <NormalLabel>{price}</NormalLabel>
      <BoldLabel>{order[variant.id]}</BoldLabel>
      <Img src={AddIcon} onClick={() => handleOrderByVariant(variant.id)} />
    </>
  )
}
export default VariantRow;